import { Component, Inject, OnInit } from "@angular/core";
import { first } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { GlobalConstants } from "../../../../common/global-constants";
import { ConfigurationService } from "../../../../services/configuration.service";
import {
  resourceTypeNameList,
  resourceNamespaceNameList,
} from "../../../../common/common-constants";

@Component({
  selector: "app-create-resource",
  templateUrl: "./create-resource.component.html",
  styleUrls: ["./create-resource.component.scss"],
})
export class CreateResourceComponent implements OnInit {
  public createResourceForm: FormGroup;
  public loading = false;
  public resourceTypeNameList: object[] = resourceTypeNameList;
  public resourceNamespaceNameList: object[] = resourceNamespaceNameList;
  public parentResourceIdList: object[] = [];
  public createBindleResourceURL =
    GlobalConstants.CREATE_BINDLE_RESOURCE_ENDPOINT;

  constructor(
    private formBuilder: FormBuilder,
    @Inject("RequestsService") private requestsService,
    @Inject("ConfigurationService")
    private readonly configurationService: ConfigurationService,
    private toastrService: ToastrService,
  ) {
    configurationService
      .getSettings()
      .pipe(first())
      .subscribe((settings) => {
        this.parentResourceIdList = settings.parentResourceIdList;
      });
  }

  ngOnInit(): void {
    this.createResourceForm = this.formBuilder.group({
      resourceName: ["", Validators.required],
      resourceTypeName: ["", Validators.required],
      resourceNamespaceName: ["", Validators.required],
      parentResourceId: ["", Validators.required],
    });
  }

  public submit() {
    const {
      resourceName,
      resourceTypeName,
      resourceNamespaceName,
      parentResourceId,
    } = JSON.parse(JSON.stringify(this.createResourceForm.value));
    // request payload mapping
    const requestBody = {
      name: resourceName,
      resourceType: {
        resourceTypeName: resourceTypeName,
        namespaceName: resourceNamespaceName,
      },
      parent: {
        resourceId: parentResourceId,
      },
    };
    // Call backend apis
    this.loading = true;
    this.requestsService
      .put(this.createBindleResourceURL, requestBody)
      .subscribe(
        (data) => {
          this.loading = false;
          this.toastrService.success(
            GlobalConstants.REQUEST_SUCCESSFUL,
            GlobalConstants.TITLE_SUCCESS,
          );
        },
        (error) => {
          this.loading = false;
          this.toastrService.error(error, GlobalConstants.TITLE_ERROR);
        },
      );
  }
}
